import { Component, OnDestroy, OnInit } from '@angular/core';
import { HeaderService } from '@shared/modules/header/services/header.service';
import { SideFilterService } from '@shared/modules/side-filter/services/side-filter.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { getTranslatePathByPageType } from '@shared/modules/header/utils/header-translate-helper.util';
import { BaseComponent } from '@shared/modules/base-component/base.component';
import { TranslationParam } from '@shared/classes/TranslationParam';
import headerActions from '@shared/modules/header/actions/header.actions';
import { AppStateService } from '@shared/services/app-state.service';
import { UserPermission } from '@shared/modules/auth/classes/UserPermission';
import { AuthUtils } from '@shared/modules/auth/utils/auth.utils';
import { AuthService } from '@shared/modules/auth/services/auth.service';

@UntilDestroy()
@Component({
  selector: 'app-main-page-header',
  templateUrl: './main-page-header.component.html',
  styleUrls: ['./main-page-header.component.scss'],
})
export class MainPageHeaderComponent extends BaseComponent implements OnInit, OnDestroy {
  isSideFilterOpen: boolean;
  filteredResultCount$: Observable<number>;
  headerTitle$: Observable<string>;
  headerButtonParams$: Observable<TranslationParam>;
  exportPermissions = [UserPermission.ExportTable];
  filterPermissions = [UserPermission.ManageFilters];
  isButtonShow = true;

  constructor(
    private headerService: HeaderService,
    private appService: AppStateService,
    private sideFilterService: SideFilterService,
    private auth: AuthService
  ) {
    super();
  }

  ngOnInit() {
    this.headerButtonParams$ = this.getHeaderButtonParams();
    this.filteredResultCount$ = this.getFilteredResultCount();
    this.headerTitle$ = this.getHeaderTitle();
    this.listenSideFilterToggleChanges();
    this.listenHeaderPermissionsChanges();
    return super.ngOnInit();
  }

  ngOnDestroy() {
    this.headerService.setState({ createButtonActionPermissions: [] });
    return super.ngOnDestroy();
  }

  onSideFilterToggle(): void {
    this.sideFilterService.toggleSideFilter(!this.isSideFilterOpen);
  }

  onExportClick(): void {
    this.headerService.eventBus.dispatch(headerActions.exportTableButtonClickAction());
  }

  onButtonClick(): void {
    this.headerService.eventBus.dispatch(headerActions.newEntityButtonClickAction());
  }

  private getHeaderTitle(): Observable<string> {
    return this.headerService.select('title');
  }

  private listenHeaderPermissionsChanges() {
    return this.headerService
      .select('createButtonActionPermissions')
      .pipe(
        tap((permissions: UserPermission[]) => {
          this.isButtonShow = AuthUtils.isContainUserPermission(
            permissions,
            this.auth.getUserRoles()
          );
        }),
        untilDestroyed(this)
      )
      .subscribe();
  }

  private listenSideFilterToggleChanges(): void {
    this.sideFilterService
      .select('isOpen')
      .pipe(
        tap((isOpen) => (this.isSideFilterOpen = isOpen)),
        untilDestroyed(this)
      )
      .subscribe();
  }

  private getFilteredResultCount(): Observable<number> {
    return this.headerService.select('filterCount');
  }

  private getHeaderButtonParams(): Observable<TranslationParam> {
    return this.appService.select('currentUrl').pipe(
      map((url: string) => ({
        entity: getTranslatePathByPageType(url),
      }))
    );
  }
}
